import { useEffect, useRef } from 'react';
import getUser from 'redux/selector/getUser';
import StorageService from 'services/StorageService';

const useTrackingElements = () => {
  const interval = useRef();
  const { isLogged } = getUser();

  useEffect(() => {
    if (!isLogged) {
      return;
    }

    const SECONDS_FOR_TRACKING = 30;
    console.log('[TRIGGER]: useTrackingElements()');

    window.onclick = function (e) {
      StorageService.handleElementClicked(e);
    };

    interval.current = setInterval(() => {
      StorageService.sendTrackingToServer();
    }, SECONDS_FOR_TRACKING * 1000);

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [isLogged]);
};

export default useTrackingElements;
